import { StatusBadge } from "@/components/admin/StatusBadge";

const fmt = (iso) => {
  try { return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
};

export const LeadsTable = ({ leads, onSelect }) => {
  if (!leads?.length) {
    return (
      <div className="bg-white border-2 border-[rgba(10,10,10,0.1)] p-12 text-center text-neutral-500 font-data text-sm" data-testid="leads-empty">
        No leads yet. Run a test on the landing page to generate one.
      </div>
    );
  }
  return (
    <div className="bg-white border-2 border-obsidian overflow-x-auto" data-testid="leads-table">
      <table className="w-full text-left border-collapse min-w-[720px]">
        <thead>
          <tr className="bg-obsidian text-white">
            {["Domain", "Phone", "Score", "Status", "Source", "Created", ""].map((h) => (
              <th key={h} className="font-data text-[11px] uppercase tracking-widest px-4 py-3 font-medium">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {leads.map((l) => (
            <tr
              key={l.id}
              className="border-b border-[rgba(10,10,10,0.08)] hover:bg-[#F9F9F9] cursor-pointer transition-colors"
              onClick={() => onSelect(l.id)}
              data-testid={`lead-row-${l.id}`}
            >
              <td className="px-4 py-3">
                <div className="font-heading font-bold text-obsidian">{l.brand}</div>
                <div className="font-data text-xs text-neutral-500">{l.domain}</div>
              </td>
              <td className="px-4 py-3 font-data text-sm text-obsidian">{l.phone_full}</td>
              <td className="px-4 py-3">
                <span className="font-data text-lg font-bold text-conversion">{l.visibility_score}</span>
                <span className="text-xs text-neutral-400">/{l.rating}</span>
              </td>
              <td className="px-4 py-3"><StatusBadge status={l.status} /></td>
              <td className="px-4 py-3 font-data text-xs text-neutral-500 uppercase">{l.source_campaign}</td>
              <td className="px-4 py-3 font-data text-xs text-neutral-500">{fmt(l.created_at)}</td>
              <td className="px-4 py-3 text-right">
                <span className="font-data text-xs text-conversion uppercase tracking-wide">View →</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LeadsTable;
